import Api from './api';

export default {
  getFeatures() {    
      let features = Api.get('FeatureApi/GetFeatures');
      return features;
  },
}